/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('creasing.matrix');

var $ = window.jQuery = require('base'), _super = require('../com.jufeng.product'), page = $.Deferred(), touchspin = require('../fabric/com.jufeng.fabric.touchSpin'); ;
_super.model_hooks = {
	'cart_details.0.value,cart_details.0.format,cart_details.0.periods' : function (el) {
		this.value = $(el).find('a.active:visible').find('input').val();
		return true;
	},
	'cart_details.0.down_payment' : function (el) {
		return $(el).is(":visible")
	}
}
$('#equipment').on('loaded', function () {
	touchspin.touch();
	page.resolve();
})

$.when(_super.model, _super.number_util, _super.layer, page, touchspin.touchdef).then(function (model_args, number_util, layer) {

	var model_factory = model_args[0],
	cur_model = model_args[1],
	model = cur_model();
	_super.qtip.done(function () {
		_super.init_qtip($('#product_main'));
	});
	$('[data-prop-path="pay_type"]').change(function () {
		$(".installment_desc").toggle();
	});
	_super.seckill_deferred.done(function (product) {
		// 恢复订购数量
		$('input[data-prop-path$="width"],input[data-prop-path$="length"],input[data-prop-path$="count"]').removeAttr('disabled');
		// 恢复抢购按钮
		$('.buy_toolbar_box .btn_multi_right .cart_btn_big', '#product_main').removeClass('none');
	})
	_super.seckill_end_deferred.done(function (product) {
		// 禁止订购数量
		$('input[data-prop-path$="width"],input[data-prop-path$="length"],input[data-prop-path$="count"]').attr('disabled', 'disabled');
		// 禁止抢购按钮
		$('.buy_toolbar_box .btn_multi_right .cart_btn_big', '#product_main').addClass('none');
	})
	// 解析数据
	$('[data-prop-path="cart_details.0.format"]').watching('cart_details.0.value', function (e, model) {
		var detail = model.cart_details[0],
		value = detail.value,
		html = '';
		var desc = rule[value];
		for (var i in desc) {
			html += '<a class="btn select_btn1"><input type="radio" name="format" value="' + i + '">' + i + '</a> ';
		}
		$(this).html(html);
		$(this).find("a").eq(0).button("toggle");
	});
	
	//更改规格/宽幅
	$({}).watching('cart_details.0.format cart_details.0.count', function (e, model) {
		var detail = model.cart_details[0],
		value = detail.value;
		if (value == "对开") {
			$("#format_name").html("激光路数")
		} else {
			$("#format_name").html("宽幅")
		}
		model = build_model(model);
		var down = model.cart_details[0].down_payment_down*detail.count,
		up = model.cart_details[0].down_payment_up*detail.count;
		$('.down_payment').siblings("span").html(" 首付范围："+down+"-"+up+"万元");
		$('.down_payment').attr("placeholder", down + "-" + up);
		$('.down_payment').val(down);
		if (!model.instalment) {
			$(".installment").remove();
		}
		$("[data-prop-path='cart_details.0.periods']").trigger("change");
		LOG.info("更改规格/宽幅");
	});
	
	//更改周期或首付
	$({}).watching('cart_details.0.periods cart_details.0.down_payment', function (e, model) {
		chooseTxt(model);
		var detail = model.cart_details[0],
		value = detail.value,
		up = model.cart_details[0].down_payment_up * detail.count;
		if (+up < +detail.down_payment) {
			$('[data-prop-path="cart_details.0.down_payment"]').trigger({
				type : 'error',
				content : '不能大于' + up+ "万元"
			});
			return false;
		}
	});
	$('[data-prop-path="pay_type"]').on("change", function () {
		$("[data-prop-path='cart_details.0.format']").trigger("change");
	});

	$("[data-prop-path='cart_details.0.count']").trigger("change");

	function chooseTxt(model) {
		_super.number_util.done(function (number_util) {
			model = build_model(model);
			var detail = model.cart_details[0],
			pay_type = model.pay_type,
			price = detail.price,
			down_payment = detail.down_payment * 10000,
			period = number_util.toFixed((price - down_payment) / detail.periods, 2);
			$('#spanAmountPrice').html(number_util.toFixed(price, 2));
			$('#j_span_sale_price').html(number_util.toFixed(detail.final_price, 2));
			$('#j_span_market_price').html(number_util.toFixed(detail.market_price, 2));
			$(".notpay").html(number_util.toFixed(price - down_payment, 2));
			$(".month").html("¥ " + number_util.toFixed(period, 2));
			$(".periods").html("x " + detail.periods + "期");
			
			$("#buy_desc").html('<p class="red">' + detail.value + '  ' + detail.format + '路    数量：' + detail.count + '</p>'
				 + '<p class="red">首付：' + detail.down_payment + ' 万   分期：' + detail.periods + ' 期   月付：¥' + period + ' 元</p>')
			//订购价
			var order_price = number_util.toFixed(price / detail.count, 2);
			$('.right > .order_price').find('span').each(function (i) {
				if (i) { 
					$(this).text("/台")
				} else {
					$(this).text(order_price);
				}
			})

		});
		LOG.info(JSON.stringify(model))
	}

	_super.before_add2cart = $.proxy(function (model_factory, cur_model) {
			// 检测各属性
			var model = cur_model(),
			cart = build_model(model);
			var detail = cart.cart_details[0],
			value = detail.value,
			down = detail.down_payment_down *detail.count,
			up = detail.down_payment_up* detail.count;
			
		if (!price_check(detail.down_payment, up, down)) {
				return false;
			}
		/*$(function () {
				var pT = $('.recemmend_desc').offset().top;
				$('.pointing').css('top', pT + 'px');
			})
			$(".pointing").addClass("active");
			layer.confirm($(".pointDrog").html(), {
				title : '温馨提示',
				closeBtn : 1,
				shade : [0.5, '#000'],
				btn : ['只购所选产品', '好的']
			}, function () {
				
				$(".pointing").removeClass("active");
			},function(){
				$("html,body").animate({scrollTop: $(".recemmend_desc").offset().top}, 1000);
				$(".pointing").removeClass("active");
			});		*/
			
			return cart;
		}, _super, model_factory, cur_model);

	function build_model(model) {
		var detail = model.cart_details[0],
		pay_type = model.pay_type,
		value = detail.value,
		format = detail.format,
		description = rule[value][format];
		detail.down_payment_down = description.down_payment_down;
		detail.down_payment_up = description.down_payment_up;
		detail.code = description.code;
		detail.final_price = description[model.pay_type];
		detail.market_price = description.market;
		detail.pack_desc = description.pack_desc;
		detail.price = +detail.final_price * +description.packaging * +detail.count * +description.buy_count;
		model.pay_type = 0;
		return model;
	}
	function price_check(value, up, down) {
		if (down > value) {
			$('[data-prop-path="cart_details.0.down_payment"]').trigger({
				type : 'error',
				content : '不能小于' + (+down) + "万元"
			});
			return false;
		}
		if (up < value) {
			$('[data-prop-path="cart_details.0.down_payment"]').trigger({
				type : 'error',
				content : '不能大于' + (+up) + "万元"
			});
			return false;
		}
		return true;
	}

	//后台修改订单初始化
	_super.init_4_back_mdf_order();
	
});

$(".ctpFix_recemmend").on("loaded",function(){
	change_combos();
	$(".combo_check").on("click",function(){
		var val = $(this).val();
		$("#"+val+"_combo").toggle();
		change_combos();
	});
	function change_combos(){
		var combo_price = 0;
		$(".combo_check:checked").each(function(){
			var value = $(this).val(),price = $("."+value+"_price").html();
			combo_price += +price;
		});
		$(".combo_price").html("¥"+combo_price);
	}
	
});





// WEBPACK FOOTER //
// ./src/main/javascript/product/equipment/com.jufeng.equipment.js